<div class="roadmap ml-3">
  @for (roadmapStep of roadmapData; track roadmapStep; let i = $index) {
    <div class="roadmap__step mr-1"
    [ngClass]="{
      'roadmap__step--check': i <= checkedIndex,
      'roadmap__step--failure': roadmapStep.indicator === 'danger',
      'roadmap__step--active': roadmapStep.indicator === 'positive'
    }">
      {{roadmapStep.name}}
      <span class="roadmap__step-tooltip pt-1 pb-1 pl-2 pr-2">
        {{roadmapStep.tooltip | translate}}
      </span>
    </div>
  }
</div>
